// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AddToCaseStudy
 */
export interface AddToCaseStudy {
    /**
     * 
     * @type {string}
     * @memberof AddToCaseStudy
     */
    itemId: string;
    /**
     * 
     * @type {number}
     * @memberof AddToCaseStudy
     */
    sectionId?: number;
}

export function AddToCaseStudyFromJSON(json: any): AddToCaseStudy {
    return {
        'itemId': json['item_id'],
        'sectionId': !exists(json, 'section_id') ? undefined : json['section_id'],
    };
}

export function AddToCaseStudyToJSON(value?: AddToCaseStudy): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'item_id': value.itemId,
        'section_id': value.sectionId,
    };
}


